import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('cbdce-article-content', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
